<form [formGroup]="formGroup">

  <div class="add-group">
    <p class="group-title">THÔNG TIN HTX</p>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Tên HTX" formControlName="cooperativeName"></dcu-input-text>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Mã HTX" [required]="true" formControlName="cooperativeCode"></dcu-input-text>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-date-picker
          formControlName="effectiveEndDate"
          [label]="'Ngày kết thúc'"
          [required]="true"
        ></dcu-date-picker>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Ngày chốt số" formControlName="closingDate" [type]="'number'" [required]="true" [maxLength]="2"></dcu-input-text>
      </div>
    </div>
  </div>

  <div class="add-group">
    <p class="group-title">THÔNG TIN TÀI KHOẢN ĐĂNG NHẬP</p>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Tên đăng nhập" [disabled]="isEdit" [required]="true" formControlName="userName"></dcu-input-text>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <dcu-input-text label="Mật khẩu" [required]="true" formControlName="password"></dcu-input-text>
      </div>
    </div>
  </div>
</form>
